

export class ExpenseAddInput implements IExpenseAddInput {
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The auto-generated id of the expense master */
    expenseTypeId!: number;
    /** The auto-generated id of the fuel station master */
    fuelStationId!: number;
    /** The type pf fuel filling should be Full or Partial */
    fillingType!: string;
    /** The auto-generated id of the fuel type master */
    fuelTypeId!: number;
    /** The Filled up liter of fuel */
    filledupLiter!: number;
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId!: number;
    /** The total amount of fuel */
    totalAmount!: number;
    /** The current odometer of vehicle */
    currentOdometer!: number;
    /** The  expense date and time */
    expenseDateTime!: string;
    /** The  description with 2000 character */
    description!: string;

    constructor(data?: IExpenseAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.fuelStationId = _data["fuelStationId"];
            this.fillingType = _data["fillingType"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.filledupLiter = _data["filledupLiter"];
            this.maintenanceTypeId = _data["maintenanceTypeId"];
            this.totalAmount = _data["totalAmount"];
            this.currentOdometer = _data["currentOdometer"];
            this.expenseDateTime = _data["expenseDateTime"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExpenseAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["expenseTypeId"] = this.expenseTypeId;
        data["fuelStationId"] = this.fuelStationId;
        data["fillingType"] = this.fillingType;
        data["fuelTypeId"] = this.fuelTypeId;
        data["filledupLiter"] = this.filledupLiter;
        data["maintenanceTypeId"] = this.maintenanceTypeId;
        data["totalAmount"] = this.totalAmount;
        data["currentOdometer"] = this.currentOdometer;
        data["expenseDateTime"] = this.expenseDateTime;
        data["description"] = this.description;
        return data; 
    }
}

export interface IExpenseAddInput {
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The auto-generated id of the expense master */
    expenseTypeId: number;
    /** The auto-generated id of the fuel station master */
    fuelStationId: number;
    /** The type pf fuel filling should be Full or Partial */
    fillingType: string;
    /** The auto-generated id of the fuel type master */
    fuelTypeId: number;
    /** The Filled up liter of fuel */
    filledupLiter: number;
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId: number;
    /** The total amount of fuel */
    totalAmount: number;
    /** The current odometer of vehicle */
    currentOdometer: number;
    /** The  expense date and time */
    expenseDateTime: string;
    /** The  description with 2000 character */
    description: string;
}

